import * as React from "react";
import { styled } from "@mui/material";
import { LandingPageCard } from "../landingPageCard";
import { ReactComponent as StartCaseIcon } from "../../../../assets/startCaseIcon.svg";
import { useDiagnosticNavigation } from "../../useDiagnosticNavigation";
import {
  defaultSuggestionsState,
  useSuggestionsState,
} from "../../../../context/diagnosticAgent";
import { usePatientCase } from "../../usePatientCase";
import { useRouteHelper } from "../../useRouteHelper";
import { useSession } from "fe-web-components/userSession/userSession";
import { ACTION, CATEGORY, evt } from "fe-common/analytics/analytics";
import { useSaveCase } from "../../saveCase/useSaveCase";
import { AgentRoute } from "../../util/agentRoutes";
import { MobileView } from "../../../../util/aKaunGeneralUtil";

//region [[ Styles ]]

const StartNewCaseCardView = styled(LandingPageCard)(({ theme }) => ({
  "& .upper-section": {
    [theme.breakpoints.down(MobileView)]: {
      flexFlow: "row-reverse",
      justifyContent: "space-between",
      flexGrow: 1,
    },
  },
  [theme.breakpoints.down(MobileView)]: {
    padding: "20px",
  },
}));

const CaseIcon = styled(StartCaseIcon)(({ theme }) => ({
  [theme.breakpoints.down(MobileView)]: {
    height: "53px",
    width: "53px",
    marginRight: "13px",
  },
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface StartNewCaseCardProps {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

//region [[ Text ]]
const startNewCaseTitle = "Start A New Case";
const startNewCaseBottomText =
  "By starting a new case, your previous case will be deleted. " +
  "[linkText=]Click here[/linkText] In order to save it. ";
//endregion [[ Text ]]

export const StartNewCaseCard = ({ ...props }: StartNewCaseCardProps) => {
  const {
    startOverDialogProps: { isLocalRestored },
    setStartOverDialogProps,
    setInWizard,
    setNextRouteNavigationDisabled,
  } = useDiagnosticNavigation();

  const [, setSuggestionState] = useSuggestionsState();

  const { handleReset } = usePatientCase();

  const { navigateTo } = useRouteHelper();

  const { resetSession } = useSession();

  const { saveCase } = useSaveCase();

  const handleStartNewCase = () => {
    setStartOverDialogProps({ open: false, isLocalRestored });
    handleReset();
    setSuggestionState(defaultSuggestionsState);
    setInWizard(true);
    setNextRouteNavigationDisabled(false);
    evt({
      category: CATEGORY.AGENT_WIZARD,
      action: ACTION.START_OVER_APPLIED,
    });
    // Support sessions not being defined (when running in editor for ex.)
    resetSession && resetSession();
    navigateTo({ route: AgentRoute.AgeAndGender });
  };

  const handleSaveCaseClicked = () => {
    saveCase();
  };

  return (
    <StartNewCaseCardView
      title={startNewCaseTitle}
      bottomText={startNewCaseBottomText}
      onClick={handleStartNewCase}
      actionView={<CaseIcon />}
      onBottomActionClicked={handleSaveCaseClicked}
    />
  );
};
